
import Vue from 'vue'
import stores from '../../store/store'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)
Vue.use(AjaxPlugin)


const baseURL =
process.env.NODE_ENV === "production"
? (window.location.origin === 'http://dev.mobile.mianhuain.com' ? 'https://dev.api.mianhuain.com/api/' : 'https://api.mianhuain.com/api/')
: "https://dev.api.mianhuain.com/api/";


const baseAjax=function(param){
let defaultParam={
baseURL:baseURL,
data:param.data || {},
params:param.params||{},
url:param.url,
type:param.type || 'get',
timeout: param.timeout || 600000,
showLoading:false,
headers:buildHeaders(param.authentication)
}

if(param.showLoading){
stores.commit('UPDATE_LOADING', true)
}

AjaxPlugin.$http.request({
baseURL: defaultParam.baseURL,
method:defaultParam.type,
url:defaultParam.url,
data:defaultParam.data,
params:defaultParam.params,
timeout:defaultParam.timeout,
headers: defaultParam.headers
}).then(function(response) {

let config = response.config;
if(config !== undefined && config.url.indexOf('/user/login') != -1){
window.sessionStorage.setItem('joinToken', response.headers.authentication);
}

if(config !== undefined && config.url.indexOf('/user/h5/sso') != -1){
window.sessionStorage.setItem('ssoToken', response.headers.authentication);
}
stores.commit('UPDATE_LOADING', false)

param.success(response.data)
}).catch(function(erro){
stores.commit('UPDATE_LOADING', false)
console.log(erro)
});

}

function buildHeaders(authentication){
let headers = {
"Client-Address":window.returnCitySN.cip,
"Timestamp":new Date().getTime(),
"Client-Type":window.sessionStorage.getItem("clientType") || "3",
"Version":"1.0.0",
"Transaction":UUID()
}

if(authentication != undefined){
headers["Authentication"] = authentication
}
return headers;
}

function S4() {
return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}

function UUID() {
return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}



const baseFun={

localSet(obj,key){
var newObj = obj;
var str = JSON.stringify(newObj);
localStorage.setItem(key,str);
},
localGet(key){
var str = localStorage.getItem(key);
if('undefined' === str){
alert('str1 =' + str)
localStorage.removeItem(key);
return 'undefined'
}else{
return JSON.parse(str);
}

},
localClear(key){
localStorage.removeItem(key);
},

getQueryString(name) {
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
var r = window.location.search.substr(1).match(reg);
if (r != null) return decodeURI(r[2]);
return null;
},
}



export default {
baseFun,
baseAjax
}





// WEBPACK FOOTER //
// ./src/assets/js/baseFun.js